import { ActivatedRoute, Router } from '@angular/router';


export interface IProposalItem {
	getId(): string;
	navigate(router: Router, activatedRoute: ActivatedRoute, returnUri: string): void;
}

export interface IProposalRefDetector {
	isCurrentProposal(): boolean;
}

export class BaseProposalItem {
	public type: string;
	public budget?: number;
	public approvedBudget?: number;
	public status: string;
	public statusId: number;
	public votes: number;
	public lastUpdated: string;
	public lastUpdatedBy: string;
	public documentsUnderReview: number;
	public createdOn: string;
}

export class BoardProposalItem extends BaseProposalItem implements IProposalItem, IProposalRefDetector {
	public smartSyncUri: string;
	public isCurrent: boolean;

	public navigate(router: Router, activatedRoute: ActivatedRoute, returnUri: string): void {
		router.navigate([...this.smartSyncUri.split('/'), 'proposals', 'details'], {
			relativeTo: activatedRoute.root,
			state: { returnUri: returnUri != null ? [...returnUri.split('/'), 'proposals'].join('/') : null }
		});
	}

	public getId(): string {
		return this.smartSyncUri;
	}

	isCurrentProposal(): boolean {
		return this.isCurrent;
	}
}

export class CustomerProposalItem extends BaseProposalItem implements IProposalItem {
	public proposalId: number;

	public navigate(router: Router, activatedRoute: ActivatedRoute, returnUri: string): void {
		router.navigate([this.proposalId + '/details'], { relativeTo: activatedRoute });
	}

	public getId(): string {
		return this.proposalId.toString();
	}
}

